import BaseScreenerWrapper from 'domains/signup/screener/base';
import { withScreenerProvider } from 'domains/signup/screener/context/screenerContext';

export default withScreenerProvider(BaseScreenerWrapper);
